import * as backofficeMocks from './backoffice.handlers';
import * as defaultMocks from './default.handlers';
import * as businessMocks from './business.handlers';

export const handlers = [
  ...businessMocks.handlers,
  ...defaultMocks.handlers,
  ...backofficeMocks.handlers,
];
